
import { PricingPlans } from "@/components/pricing/PricingPlans";
import { useSubscriptionHandler } from "@/hooks/useSubscriptionHandler";
import { PricingFAQ } from "@/components/pricing/PricingFAQ";


const Pricing = () => {
  const { handleSubscribe } = useSubscriptionHandler();

  return (
    <div className="container mx-auto py-12 px-4">
      <div className="text-center mb-12">
        <h1 className="text-4xl font-bold mb-4">Nos tarifs</h1>
        <p className="text-gray-600 max-w-2xl mx-auto mb-4">
          Choisissez le plan qui correspond le mieux à vos besoins. Commencez par un essai gratuit de 14 jours avec la création manuelle, sans carte bancaire.
        </p>
        
      </div>

      <PricingPlans 
        currentLanguage="fr"
        onSubscribe={(planType, paymentMethod, couponCode, billingPeriod) => 
          handleSubscribe(planType, paymentMethod, couponCode, billingPeriod)
        }
      />

      <PricingFAQ />
    </div>
  );
};

export default Pricing;
